module.exports = __webpack_public_path__ + "static/media/draft (1).567ad11e.svg";